import React from "react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import TermsAndConditionsModal from "../../../components/taxDeclaration/termsConditionsModal/TermsAndConditionsModal";
import styleListData from "./ListData.module.css";
import MainContent from "../../../layouts/maincontent/MainContent";
import Pagination from "../../../shared/pagination/Pagination";
import { TaxDeclartionProvider } from "../../../contexts/TaxDeclaration";
import SelectElement from "../../../shared/form/SelectElement";
import InputElement from "../../../shared/form/InputElement";
import { get_tax_declarations } from "../../../adapters/apis/taxDeclaration/list";
import {
  getDeclarationRealEstateTypes,
  getDeclarationStatusList,
} from "../../../adapters/apis/lookups/lookups";
import Moment from "moment";
import LoadingSpinner from "../../../components/Loading/LoadingSpinner";
import DatePickerFormated from "../../../shared/form/DatePickerFormated";
import { deleteTaxDeclaration } from "../../../adapters/apis/taxDeclaration/delete";
function ListData() {
  const [buildingType, setBuildingType] = useState([]);
  const [deleteID, setDeleteID] = useState(0);
  const [tax_declarations, setTaxDeclarations] = useState([]);
  const [declarationsLength, setDeclarationsLength] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [startFrom, setStartFrom] = useState(1);
  const [active, setActive] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [statusList, setStatusList] = useState([]);

  const limit = 10;

  const [filters, setFilters] = useState({
    person_name: "",
    building_type_id: "",
    from_date: "",
    to_date: "",
    status: "",
    offset: limit,
  });

  const [filtersErrors, setFiltersErrors] = useState({
    person_name: "",
    building_type_id: "",
    from_date: "",
    to_date: "",
    status: "",
  });

  const [success, setSuccess] = useState("");

  const changeDataFormat = (filters) => {
    const data = {
      person_name: filters?.person_name,
      building_type_id: filters?.building_type_id,
      from_date: filters?.from_date
        ? Moment(filters?.from_date).format("yyyy-MM-DD")
        : "",
      to_date: filters?.to_date
        ? Moment(filters?.to_date).format("yyyy-MM-DD")
        : "",
      status: filters?.status,
      offset: limit,
    };
    return data;
  };
  const handlerDeleteTaxDecleration = (id) => {
    setDeleteID(id);
  };
  useEffect(() => {
    setIsLoading(true);

    if (localStorage.getItem("success")) {
      setSuccess(localStorage.getItem("success"));
      localStorage.removeItem("success");
    }

    // get tax_declarations for logged user
    get_tax_declarations({}, currentPage, changeDataFormat(filters)).then(
      (res) => {
        setDeclarationsLength(res?.data?.data?.total);
        setTaxDeclarations(res?.data?.data?.data);
        setCurrentPage(res?.data?.data?.current_page);
        setStartFrom(res?.data?.data?.from);
        setIsLoading(false);
      }
    ).catch((err) => {
      console.log(err);
    });

    // set Declaration Real Estate Type
    getDeclarationRealEstateTypes().then((res) => {
      setBuildingType(res?.data?.data);
    }).catch((err) => {
      console.log(err);
    });

    // set Declaration Real Estate Type
    getDeclarationStatusList().then((res) => {
      setStatusList(res?.data?.data);
    }).catch((err) => {
      console.log(err);
    });
  }, [active]);

  function callback(active) {
    setIsLoading(true);
    setCurrentPage(active);
    get_tax_declarations({}, active, changeDataFormat(filters)).then((res) => {
      setDeclarationsLength(res?.data?.data?.total);
      setTaxDeclarations(res?.data?.data?.data);
      setStartFrom(res?.data?.data?.from);
      setIsLoading(false);
    }).catch((err) => {
      console.log(err);
    });
  }
  function deleteTaxDeclartion(taxDeclarationID) {
    deleteTaxDeclaration(taxDeclarationID)
      .then((res) => {
        setCurrentPage(1);
        get_tax_declarations({}, 1, changeDataFormat(filters)).then((res) => {
          setDeclarationsLength(res?.data?.data?.total);
          setTaxDeclarations(res?.data?.data?.data);
          setCurrentPage(res?.data?.data?.current_page);
          setStartFrom(res?.data?.data?.from);
        });
      })
      .catch((err) => {
        if (!err?.response) {
          console.log("No Server Response");
        } else if (err?.response?.status === 500) {
          console.log("server error: ", err?.response?.data?.message);
        }
      });
  }

  const data = tax_declarations?.map((element, index) => {
    return (
      <tr key={element.id}>
        <td data-label="التسلسل">{index + startFrom}</td>
        <td data-label="رقم الإقرار">
          {element?.declaration_num ? element?.declaration_num : ""}
        </td>
        <td data-label="أسم المالك">
          {parseInt(element?.owner_type) === 1
            ? element?.first_name + " " + element.fourth_name
            : element?.legal_entity_name
            ? element?.legal_entity_name
            : ""}
        </td>
        <td data-label="تاريخ الإقرار">
          {Moment(element?.created_at).format(" D/M/y")}
        </td>
        <td data-label="نوع العقار">
          {element?.real_estate_type_text ? element?.real_estate_type_text : ""}
        </td>
        <td data-label="نوع الاستغلال">
          {element?.exploitation_type_text ? element?.exploitation_type_text : ""}
        </td>
        <td data-label="تفاصيل">
          {parseInt(element.status) === 2 ? (
            <Link
              to={"/tax-declaration/details/" + element.id}
              className={styleListData["btn-file"]}
            >
              <i className="fa-regular fa-file-lines fa-2xl"></i>
            </Link>
          ) : (
            <>
              <Link
                to={"/tax-declaration/update/" + element.id}
                className={styleListData["btn-file"]}
              >
                <i className="fa-regular fa-pen-to-square fa-xl"></i>
              </Link>
              <button
                onClick={() => handlerDeleteTaxDecleration(element.id)}
                data-bs-toggle="modal"
                data-bs-target="#deleteTaxDeclartion"
                className="text-danger border-0 bg-transparent pe-3"
              >
                <i className="fa-regular fa-trash-can fa-xl"></i>
              </button>
            </>
          )}
        </td>
      </tr>
    );
  });
  const buildingType_options = buildingType?.map((element) => {
    return (
      <option value={element?.id} key={element?.id}>
        {element?.name}
      </option>
    );
  });

  const status_options = statusList?.map((element) => {
    return (
      <option value={element?.id} key={element?.id}>
        {element?.name}
      </option>
    );
  });

  function search() {
    //call api to get tax declaration with filters
    setCurrentPage(1);
    get_tax_declarations({}, 1, changeDataFormat(filters)).then((res) => {
      setDeclarationsLength(res?.data?.data?.total);
      setTaxDeclarations(res?.data?.data?.data);
      setCurrentPage(res?.data?.data?.current_page);
      setStartFrom(res?.data?.data?.from);
    }).catch((err) => {
      console.log(err);
    });
  }
  function changeFilters(parentCompenent, compenent, key, value) {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  }

  return (
    <MainContent>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <section className={`${styleListData.listData}`}>
          <div className="container pt-4">
            <div className={styleListData.box}>
              <div className={`${styleListData["box-header"]}`}>
                <h3 className={`${styleListData["box-title"]} mb-0`}>
                  طلبات الإقرارات الشاملة
                </h3>
                <div className={styleListData["btns-header"]}>
                  <button
                    className={styleListData["btns-header-order"]}
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                  >
                    إضافة إقرار
                  </button>
                </div>
              </div>
              <div className={`${styleListData["box-body"]} mt-3`}>
                <div className={`${styleListData["box-body-content"]}`}>
                  {success !== "" && (
                    <div className="row align-items-center">
                      <div className="col-md-12 alert alert-primary">
                        {success}
                      </div>
                    </div>
                  )}
                  <div className="row align-items-center pe-md-4">
                    <div className="col-lg-2 col-md-4">
                      <InputElement
                        name="person_name"
                        mb4="mb-4"
                        labelHtmlFor="person_name"
                        labelClassName={`  ${styleListData["form-label"]} form-label`}
                        labelText="أسـم المالك"
                        inputType="text"
                        inputClassName={`${styleListData["form-control"]} form-control`}
                        inputID="person_name"
                        pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                        value={filters?.person_name}
                        onChange={changeFilters}
                        pText={filtersErrors?.person_name}
                        maxLength="255"
                      />
                    </div>
                    <div className="col-lg-2 col-md-4">
                      <SelectElement
                        mb4="mb-4"
                        labelHtmlFor="building_type_id"
                        labelClassName={`  form-label ${styleListData["form-label"]}`}
                        labelText="نـوع العقار"
                        selectClassName={`${styleListData["form-select"]} form-select`}
                        selectID="building_type_id"
                        name="building_type_id"
                        options={buildingType_options}
                        default="أختار نوع العقار .."
                        pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                        value={filters?.building_type_id}
                        onChange={changeFilters}
                        pText={filtersErrors?.building_type_id}
                      />
                    </div>
                    <div className="col-lg-2 col-md-4">
                      <DatePickerFormated
                        name="from_date"
                        name_datepicker="from_date"
                        mb4="mb-4"
                        labelHtmlFor="from_date"
                        labelClassName={`  ${styleListData["form-label"]} form-label`}
                        labelText="من تـاريخ"
                        inputType="datePicker"
                        max={Moment().subtract(500, "years")}
                        min={Moment().subtract(18, "years")}
                        inputClassName={`${styleListData["form-control"]} form-control`}
                        inputID="to_dfrom_dateate"
                        pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                        pText={filtersErrors?.from_date}
                        value={filters?.from_date}
                        valueDate={filters?.from_date}
                        onChange={changeFilters}
                      />
                    </div>
                    <div className="col-lg-2 col-md-4">
                      <DatePickerFormated
                        name="to_date"
                        name_datepicker="to_date"
                        mb4="mb-4"
                        labelHtmlFor="to_date"
                        labelClassName={`  ${styleListData["form-label"]} form-label`}
                        labelText="إلي تـاريخ"
                        inputType="datePicker"
                        max={Moment().subtract(500, "years")}
                        min={Moment().subtract(18, "years")}
                        inputClassName={`${styleListData["form-control"]} form-control`}
                        inputID="to_date"
                        pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                        pText={filtersErrors?.to_date}
                        value={filters?.to_date}
                        valueDate={filters?.to_date}
                        onChange={changeFilters}
                      />
                    </div>
                    <div className="col-lg-2 col-md-4">
                      <SelectElement
                        mb4="mb-4"
                        labelHtmlFor="status"
                        labelClassName={`  form-label ${styleListData["form-label"]}`}
                        labelText="حالة الاقرار"
                        selectClassName={`${styleListData["form-select"]} form-select`}
                        selectID="status"
                        name="status"
                        options={status_options}
                        default="أختار حالة الاقرار .."
                        pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                        value={filters?.status}
                        onChange={changeFilters}
                        pText={filtersErrors?.status}
                      />
                    </div>
                    <div className="col-lg-2 col-md-4 text-center">
                      <button
                        className={styleListData["btns-search"]}
                        onClick={search}
                      >
                        بحث
                      </button>
                    </div>
                  </div>
                  <div
                    className={`${styleListData["table-responsive"]} table-responsive`}
                  >
                    <table className="table">
                      <thead>
                        <tr>
                          <th scope="col">التسلسل</th>
                          <th scope="col">رقم الإقرار</th>
                          <th scope="col">أسم المالك</th>
                          <th scope="col">تاريخ الإقرار</th>
                          <th scope="col">نوع العقار</th>
                          <th scope="col">نوع الاستغلال</th>
                          <th scope="col">تفاصيل</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.length > 0 ? (
                          data
                        ) : (
                          <tr>
                            <td colSpan={6} className="h5 text-center">
                              لا توجد إقرارات
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                {declarationsLength > limit ? (
                  <Pagination
                    limit={limit}
                    count={declarationsLength}
                    active={currentPage}
                    callback={callback}
                  />
                ) : (
                  ""
                )}
              </div>
            </div>
            <TaxDeclartionProvider>
              <TermsAndConditionsModal />
            </TaxDeclartionProvider>
            <div
              className="modal fade"
              id="deleteTaxDeclartion"
              role="dialog"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
              data-bs-backdrop="static"
              data-bs-keyboard="false"
            >
              <div
                className="modal-dialog modal-dialog-centered"
                role="document"
              >
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">
                      تأكيد مسح الاقرار
                    </h5>
                    <button
                      type="button"
                      className="text-danger border-0 bg-transparent"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      onClick={() => setDeleteID(0)}
                    >
                      <i className="fa-regular fa-circle-xmark fa-xl"></i>
                    </button>
                  </div>
                  <div className="modal-body">
                    <h2>هل تريد مسح الاقرار ؟</h2>
                  </div>
                  <div className="modal-footer d-flex justify-content-between">
                    <button
                      type="button"
                      className="btn btn-primary"
                      data-bs-dismiss="modal"
                      onClick={() => deleteTaxDeclartion(deleteID)}
                    >
                      موافـــق
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      onClick={() => setDeleteID(0)}
                    >
                      لا اوافــق
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </MainContent>
  );
}

export default ListData;
